"use strict";

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.regexp.split");

exports.__esModule = true;
exports.utils = exports.getWorksheetColumnWidths = exports.getJsonSheetRow = exports.getContentProperty = void 0;

var xlsx_1 = require("xlsx");

exports.utils = xlsx_1.utils;

var getContentProperty = function getContentProperty(content, property) {
  var accessContentProperties = function accessContentProperties(content, properties) {
    var value = content[properties[0]];

    if (properties.length === 1) {
      return value !== null && value !== void 0 ? value : "";
    }

    if (value === undefined || typeof value === "string" || typeof value === "boolean" || typeof value === "number" || value instanceof Date) {
      return "";
    }

    return accessContentProperties(value, properties.slice(1));
  };

  var properties = property.split(".");
  return accessContentProperties(content, properties);
};

exports.getContentProperty = getContentProperty;

var getJsonSheetRow = function getJsonSheetRow(content, columns) {
  var jsonSheetRow = {};
  columns.forEach(function (column) {
    if (typeof column.value === "function") {
      jsonSheetRow[column.label] = column.value(content);
    } else {
      jsonSheetRow[column.label] = getContentProperty(content, column.value);
    }
  });
  return jsonSheetRow;
};

exports.getJsonSheetRow = getJsonSheetRow;

var applyColumnFormat = function applyColumnFormat(worksheet, columnIds, columnFormats) {
  var _a;

  for (var i = 0; i < columnIds.length; i += 1) {
    var columnFormat = columnFormats[i];

    if (!columnFormat) {
      continue;
    }

    var column = xlsx_1.utils.decode_col(columnIds[i]);
    var range = xlsx_1.utils.decode_range((_a = worksheet["!ref"]) !== null && _a !== void 0 ? _a : "");

    for (var row = range.s.r + 1; row <= range.e.r; ++row) {
      var ref = xlsx_1.utils.encode_cell({
        r: row,
        c: column
      });

      if (worksheet[ref]) {
        worksheet[ref].z = columnFormat;
      }
    }
  }
};

var getWorksheetColumnIds = function getWorksheetColumnIds(worksheet) {
  var _a;

  var columnRange = xlsx_1.utils.decode_range((_a = worksheet["!ref"]) !== null && _a !== void 0 ? _a : "");
  var columnIds = [];

  for (var C = columnRange.s.c; C <= columnRange.e.c; C++) {
    var address = xlsx_1.utils.encode_col(C);
    columnIds.push(address);
  }

  return columnIds;
};

var getObjectLength = function getObjectLength(object) {
  if (typeof object === "string") {
    return object.length;
  }

  if (typeof object === "number") {
    return object.toString().length;
  }

  if (typeof object === "boolean") {
    return object ? "true".length : "false".length;
  }

  if (object instanceof Date) {
    return object.toString().length;
  }

  return 0;
};

var getWorksheetColumnWidths = function getWorksheetColumnWidths(worksheet, extraLength) {
  if (extraLength === void 0) {
    extraLength = 1;
  }

  var columnLetters = getWorksheetColumnIds(worksheet);
  return columnLetters.map(function (column) {
    var columnCells = Object.keys(worksheet).filter(function (cell) {
      return cell.replace(/[0-9]/g, "") === column;
    });
    var maxWidthCell = columnCells.reduce(function (maxWidth, cellId) {
      var cell = worksheet[cellId];
      var cellContentLength = getObjectLength(cell.v);

      if (!cell.z) {
        return Math.max(maxWidth, cellContentLength);
      }

      var cellFormatLength = cell.z.length;
      var largestWidth = Math.max(cellContentLength, cellFormatLength);
      return Math.max(maxWidth, largestWidth);
    }, 0);
    return {
      width: maxWidthCell + extraLength
    };
  });
};

exports.getWorksheetColumnWidths = getWorksheetColumnWidths;

var getWorksheet = function getWorksheet(jsonSheet, settings) {
  var jsonSheetRows;

  if (jsonSheet.content.length > 0) {
    jsonSheetRows = jsonSheet.content.map(function (contentItem) {
      return getJsonSheetRow(contentItem, jsonSheet.columns);
    });
  } else {
    jsonSheetRows = jsonSheet.columns.map(function (column) {
      var _a;

      return _a = {}, _a[column.label] = "", _a;
    });
  }

  var worksheet = xlsx_1.utils.json_to_sheet(jsonSheetRows);
  var worksheetColumnIds = getWorksheetColumnIds(worksheet);
  var worksheetColumnFormats = jsonSheet.columns.map(function (jsonSheetColumn) {
    var _a;

    return (_a = jsonSheetColumn.format) !== null && _a !== void 0 ? _a : null;
  });
  applyColumnFormat(worksheet, worksheetColumnIds, worksheetColumnFormats);
  worksheet["!cols"] = getWorksheetColumnWidths(worksheet, settings.extraLength);
  return worksheet;
};

var writeWorkbook = function writeWorkbook(workbook, settings) {
  var _a, _b, _c, _d;

  var _e;

  if (settings === void 0) {
    settings = {};
  }

  var RTL = Boolean(settings.RTL);
  (_a = workbook.Workbook) !== null && _a !== void 0 ? _a : workbook.Workbook = {};
  (_b = (_e = workbook.Workbook).Views) !== null && _b !== void 0 ? _b : _e.Views = [{}];
  workbook.Workbook.Views.forEach(function (view) {
    view.RTL = RTL;
  });
  var filename = "".concat((_c = settings.fileName) !== null && _c !== void 0 ? _c : "Spreadsheet", ".xlsx");
  var writeOptions = (_d = settings.writeOptions) !== null && _d !== void 0 ? _d : {};

  if (settings.writeMode === "write") {
    return (0, xlsx_1.write)(workbook, writeOptions);
  } else if (settings.writeMode === "writeFile") {
    return (0, xlsx_1.writeFile)(workbook, filename, writeOptions);
  } else {
    return writeOptions.type === "buffer" ? (0, xlsx_1.write)(workbook, writeOptions) : (0, xlsx_1.writeFile)(workbook, filename, writeOptions);
  }
};

var xlsx = function xlsx(jsonSheets, settings, workbookCallback) {
  if (settings === void 0) {
    settings = {};
  }

  if (workbookCallback === void 0) {
    workbookCallback = function workbookCallback() {};
  }

  if (jsonSheets.length === 0) return;
  var workbook = xlsx_1.utils.book_new();
  jsonSheets.forEach(function (actualSheet, actualIndex) {
    var _a;

    var worksheet = getWorksheet(actualSheet, settings);
    var worksheetName = (_a = actualSheet.sheet) !== null && _a !== void 0 ? _a : "Sheet ".concat(actualIndex + 1);
    xlsx_1.utils.book_append_sheet(workbook, worksheet, worksheetName);
  });
  workbookCallback(workbook);
  return writeWorkbook(workbook, settings);
};

exports["default"] = xlsx;
module.exports = xlsx;
module.exports.getContentProperty = getContentProperty;
module.exports.getJsonSheetRow = getJsonSheetRow;
module.exports.getWorksheetColumnWidths = getWorksheetColumnWidths;
module.exports.utils = xlsx_1.utils;